import { render } from "./SportDiscoverTeamsOrganize.vue?vue&type=template&id=6bc4e471&scoped=true"
import script from "./SportDiscoverTeamsOrganize.vue?vue&type=script&lang=js"
export * from "./SportDiscoverTeamsOrganize.vue?vue&type=script&lang=js"

import "./SportDiscoverTeamsOrganize.vue?vue&type=style&index=0&id=6bc4e471&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bc4e471"]])

export default __exports__